/**
 * A window of at most `maxVisible` consecutive pages containing `current`,
 * centred when possible and clamped at both ends.
 */
export function visiblePages(current: number, total: number, maxVisible = 5): number[] {
    if (total < 1 || maxVisible < 1) return [];
    const size = Math.min(maxVisible, total);
    const start = Math.max(1, Math.min(current - Math.floor(size / 2), total - size + 1));
    return Array.from({ length: size }, (_, i) => start + i);
}
